module.exports = __webpack_public_path__ + "static/media/smart-city.6551af4c.svg";